import _get from 'lodash/get';

import LOGIN_TEMPLATE from 'dictionary/loginPageTemplateIds';
import isHoneylove from 'utils/retailer/isHoneylove';

function formatStoreProperties(storeProperties) {
  let websiteName;
  try {
    const { host, pathname } = new URL(storeProperties.store_website);
    websiteName = `${host}${pathname}`.replace(/\/$/, '');
  } catch (e) {
    websiteName = storeProperties.store_website;
  }

  const storeDetailsObject = {
    name: storeProperties.store_name,
    storeUnquieName: storeProperties.store_unique_name,
    isSSRStore: storeProperties.is_ssr_retailer,
    email: isHoneylove() ? '' : storeProperties.store_support_email,
    website: storeProperties.store_website,
    websiteName,
    returnPolicyPage: storeProperties.store_return_policy_link,
    logo: _get(storeProperties, 'store_image_links.logo'),
    favicon: _get(storeProperties, 'store_image_links.favicon'),
    isGiftReturnEnabled: storeProperties.is_gift_return_enabled,
    sizeChartLink: storeProperties.store_sizing_guide_link,
    loginBackground: _get(
      storeProperties,
      'store_image_links.login_background_image.order_return',
    ),
    giftReturnBackground: _get(
      storeProperties,
      'store_image_links.login_background_image.gift_return',
    ),
    logoHeights: storeProperties.logo_height,
    retailerPhone: storeProperties.retailer_phone,
    allowOutOfStockExchange: storeProperties.honour_inventory_policy,
    storeOrderText: {
      example: _get(storeProperties, 'order.name_example'),
      helpText: _get(storeProperties, 'order.name_help_text'),
      nameRegEx: _get(storeProperties, 'order.name_regex'),
      nameImage: _get(storeProperties, 'order.name_image'),
    },
    serviceLabel: {
      name: _get(storeProperties, 'service_label.name'),
    },
    retailer_id: storeProperties.retailer_id,
    aspencxBranding: storeProperties.aspencx_branding,
    storeTheme: _get(storeProperties, 'store_color_theme.overrides', {}),
    allowGiftReturns: _get(storeProperties, 'is_gift_return_order_enabled'),
    loginPageTemplate: _get(
      storeProperties,
      'store_color_theme.login_page_template',
      LOGIN_TEMPLATE.ONE,
    ),
  };

  return storeDetailsObject;
}

export default formatStoreProperties;
